<div class="login-screen" id="myCheck">
  <div class="login-wrapper">
    <div class="row">
      <div class="login-logo"></div>
    </div>
    <form>
      <!-- Ajout d'un nouveau titre et texte explicatif -->
      <div class="password-reset-header">
        <h2 translate>lostpassword.ForgotPassword</h2>
        <p translate>lostpassword.PleaseEnterYourEmail</p>
      </div>

      <input id="email-input" type="email" name="email" placeholder="{{('lostpassword.YourEmail' | translate)}}"
        [formControl]="emailFormControl">
      <div class="row">
        <mat-error *ngIf="emailFormControl.dirty && emailFormControl.hasError('required')"
          translate>lostpassword.EmailIsRequired</mat-error>
      </div>
      <div class="row">
        <mat-error *ngIf="emailFormControl.dirty && emailFormControl.hasError('invalidEmail')"
          translate>lostpassword.EmailIsInvalid</mat-error>
      </div>

      <div>
        <button class="login-btn" [disabled]="!emailFormControl.valid || loading" type="input" (click)="sendMail()"
          translate>lostpassword.SendLink</button>
      </div>

      <div *ngIf="loading" translate>
        <mat-spinner></mat-spinner>
      </div>

    </form>
    <div class="row">
      <button [routerLink]="['/login']" class="forgot-btn" translate>lostpassword.Login</button>
    </div>
  </div>
</div>